<template>
    <div id="on-init" class="on-init">
        <b-modal
            id="on-init-modal"
            ref="on-init-modal"
            :title="init_data.title"
            :title-class="['h4','text-primary']"
            centered
            size="lg"
            header-bg-variant="secondary"
            header-close-variant="dark"
            header-text-variant="secondary"
            cancel-title = "Cerrar"
            ok-title="Entiendo"
            ok-only
            @hidden="hiddenModal"
            >
            <div v-html="init_data.content"></div>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    name: 'OnInitModal',
    props: {
      init_data: { type: Object, default: () => ({}) },
    },
    data() {
        return {
        }
    },
    methods: {
      showModal() {
        this.$bvModal.show('on-init-modal')
      },
      hiddenModal() {
        this.$emit('closed')
      },
    },
    mounted () {
      this.showModal()
    },
})
</script>

<style lang="scss" scoped>
  @import '../../styles/app';
  #on-init {

  }
</style>